export default "__VITE_ASSET__4YZKMZZe__"